<template>
  <v-container>
    <div class="breadcrumbs-wrap">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    </div>
    <h1 class="title-pg">{{ $t('Редактирование') }}</h1>
    <div class="my-organization">
      <div class="bso-reports hunters-pg create bgw-pdg-20">
        <v-form ref="form" @submit.prevent="save" lazy-validation>
          <div class="tab-main">
            <v-tabs
              v-model="tabHunters"
              background-color="transparent"
              color="#333"
              slider-color="transparent"
            >
              <v-tab>{{ $t('Данные охотника') }}</v-tab>
              <v-tab>{{ $t('Охотоудостоверения') }}</v-tab>
              <v-tab>{{ $t('Сведения об аттестации') }}</v-tab>
              <v-tab>{{ $t('Животные') }}</v-tab>
              <v-tab-item class="pb-2">
                <v-row>
                  <v-col cols="12" md="4" :class="{ invalid: $v.hunter.lastName.$error }">
                    <label>{{ $t('Фамилия') }}:</label>
                    <v-text-field
                      v-model="hunter.lastName"
                      outlined
                      dense
                    />
                  </v-col>
                  <v-col cols="12" md="4" :class="{ invalid: $v.hunter.firstName.$error }">
                    <label>{{ $t('Имя') }}:</label>
                    <v-text-field
                      v-model="hunter.firstName"
                      outlined
                      dense
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <label>{{ $t('Отчество') }}:</label>
                    <v-text-field
                      v-model="hunter.secondName"
                      outlined
                      dense
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4" :class="{ invalid: $v.hunter.birthDate.$error }">
                    <label>{{ $t('Дата рождения') }}:</label>
                    <div class="datepicker-main">
                      <div class="form-date mx-form-date">
                        <v-icon class="date-icon">date_range</v-icon>
                        <date-picker
                          v-model="hunter.birthDate"
                          valueType="DD.MM.YYYY"
                          :editable="true"
                          format="DD.MM.YYYY"
                          :clearable="true"
                        />
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4" :class="{ invalid: $v.hunter.country.$error }">
                    <label>{{ $t('Гражданство') }}:</label>
                    <div class="select-def">
                      <v-autocomplete
                        :items="refCountry"
                        item-value="id"
                        item-text="transName"
                        v-model="hunter.country"
                        outlined
                        dense
                        required
                        clearable
                      />
                    </div>
                  </v-col>
                  <v-col cols="12" md="4" :class="{ invalid: $v.hunter.gender.$error }">
                    <div class="radio-groups">
                      <v-radio-group v-model="hunter.gender">
                        <v-radio v-for="(gender, key) in refGender" :key="key"
                                 :label="gender.transName"
                                 :value="gender.id"
                        ></v-radio>
                      </v-radio-group>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4" v-if="hunter.country === KyrgyzstanCountry"
                         :class="{ invalid: $v.hunter.pin.$error }">
                    <label>{{ $t('ПИН') }}:</label>
                    <v-text-field
                      v-model="hunter.pin"
                      outlined
                      dense
                    />
                  </v-col>
                  <v-col cols="12" md="4" :class="{ invalid: $v.hunter.passport.$error }">
                    <label>{{ hunter.country === KyrgyzstanCountry ? $t('ID-карта') : $t('Номер паспорта') }}:</label>
                    <v-text-field
                      v-model="hunter.passport"
                      outlined
                      dense
                    />
                  </v-col>
                  <v-col cols="12" md="4" v-if="hunter.country === KyrgyzstanCountry">
                    <label>{{ $t('Кем выдан') }}:</label>
                    <v-text-field
                      v-model="hunter.issuedBy"
                      outlined
                      dense
                    />
                  </v-col>
                  <v-col cols="12" md="8" v-if="hunter.country !== KyrgyzstanCountry">
                    <label>{{ $t('Данные разрешенного оружия') }}:</label>
                    <v-text-field
                      v-model="hunter.weaponData"
                      outlined
                      dense
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4">
                    <label>{{ $t('Телефон') }}:</label>
                    <v-text-field
                      v-model="hunter.phone"
                      outlined
                      dense
                    />
                  </v-col>
                  <v-col cols="12" md="8">
                    <label>{{ $t('Адрес') }}:</label>
                    <v-text-field
                      v-model="hunter.address"
                      outlined
                      dense
                    />
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item class="pb-2">
                <TicketModal v-bind:tickets.sync="tickets" :editable="true" :hunterId="hunter.id"/>
              </v-tab-item>
              <v-tab-item class="pb-2">
                <CertificateModal v-bind:certificates.sync="certifications" :editable="true" :hunterId="hunter.id"/>
              </v-tab-item>
              <v-tab-item class="pb-2">
                <AnimalModal v-bind:animals.sync="animals" :editable="true" :hunterId="hunter.id"/>
              </v-tab-item>
            </v-tabs>
          </div>
          <!--Кнопки действии-->
          <div class="form-action text-center">
            <button
              class="btn btn-default blue"
              type="submit"
            >
              {{ $t('Сохранить') }}
            </button>
            <button
              class="btn btn-default gray"
              type="button"
              @click="onCancel"
            >
              {{ $t('Отмена') }}
            </button>
          </div>
        </v-form>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import CertificateModal from '@/components/hunter/CertificateModal'
import Hunters from '@/model/hunters'
import { maxLength, minLength, required, requiredIf } from 'vuelidate/lib/validators'
import TicketModal from '@/components/hunter/TicketModal'
import AnimalModal from '@/components/hunter/AnimalModal'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/ru'

export default {
  components: {
    AnimalModal,
    TicketModal,
    CertificateModal,
    DatePicker
  },
  data: () => ({
    breadcrumbs: [],
    tabHunters: null,
    hunter: {},
    showInfo: false,
    tickets: [],
    certifications: [],
    animals: [],
    refCountry: [],
    refGender: [],
    KyrgyzstanCountry: null,
    rules: {
      hunter: {
        lastName: { required },
        firstName: { required },
        country: { required },
        gender: { required },
        birthDate: { required },
        passport: { required },
        pin: {
          required: requiredIf(
            function () {
              return this.hunter.country === this.KyrgyzstanCountry
            }),
          minLength: minLength(14),
          maxLength: maxLength(14)
        }
      }
    }
  }),
  validations () {
    return this.rules
  },
  mounted () {
    this.fetchData()
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    // получаем данные
    fetchData () {
      this.setLoading(true)
      Hunters.getFormData().then((response) => {
        this.refCountry = response.data.refCountry
        this.refGender = response.data.refGender
        if (this.$route.query.tabHunters) {
          this.tabHunters = parseInt(this.$route.query.tabHunters)
        }
        Hunters.getInfo(this.$route.params.id).then((response) => {
          this.hunter = response.data.ooptHunter
          this.tickets = response.data.tickets
          this.certifications = response.data.certifications
          this.animals = response.data.animals
          this.KyrgyzstanCountry = response.data.KyrgyzstanCountry
          this.generateBreadcrumbs()
          this.setLoading(false)
        }).catch((error) => {
          this.$router.push({
            name: 'error',
            params: {
              status: error.response.status
            }
          })
        })
      }).catch((error) => {
        this.$router.push({
          name: 'error',
          params: {
            status: error.response.status
          }
        })
      })
      this.setLoading(false)
    },
    save () {
      if (!this.validateForm()) {
        return
      }
      this.setLoading(true)
      const fd = {
        lastName: this.hunter.lastName,
        firstName: this.hunter.firstName,
        secondName: this.hunter.secondName,
        country: this.hunter.country,
        birthDate: this.hunter.birthDate,
        gender: this.hunter.gender,
        pin: this.hunter.country === this.KyrgyzstanCountry ? this.hunter.pin : null,
        passport: this.hunter.passport,
        phone: this.hunter.phone,
        address: this.hunter.address,
        issuedBy: this.hunter.country === this.KyrgyzstanCountry ? this.hunter.issuedBy : null,
        weaponData: this.hunter.country !== this.KyrgyzstanCountry ? this.hunter.weaponData : null
      }
      Hunters.update(this.$route.params.id, fd).then((response) => {
        if (response.status === 202) {
          this.onCancel()
        }
      }).catch((error) => {
        let msg = error.message
        if (error.response) {
          if (error.response.data.form) {
            msg = this.$i18n.t(error.response.data.form.message)
          } else if (error.response.data.message) {
            msg = this.$i18n.t(error.response.data.message)
          }
        }
        this.$noty.error(msg, {
          killer: true,
          timeout: 1000,
          layout: 'topRight'
        })
      })
      this.setLoading(false)
    },
    // Валидация формы
    validateForm () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$nextTick(() => {
          this.scrollToFirstError()
        })

        return false
      }

      return true
    },
    // Прокручивание до поля с ошибкой
    scrollToFirstError () {
      this.langNpaTab = 0
      const domRect = document.querySelector('.invalid').getBoundingClientRect()
      window.scrollTo(
        domRect.left +
        (document.body.scrollLeft || document.documentElement.scrollLeft),
        domRect.top +
        (document.body.scrollTop || document.documentElement.scrollTop) -
        90
      )
    },
    // Отмена
    onCancel () {
      this.$router.push({
        name: 'hunter-show',
        params: {
          id: this.$route.params.id
        }
      })
    },
    // генерация хлебных крошек
    generateBreadcrumbs () {
      this.breadcrumbs = [
        {
          text: this.$i18n.t('Главная'),
          disabled: false,
          href: '/'
        },
        {
          text: this.$i18n.t('Охотники'),
          disabled: false,
          href: '/hunters-list'
        },
        {
          text: this.$i18n.t('Просмотр'),
          disabled: false,
          href: '/hunter-show/' + this.$route.params.id
        },
        {
          text: this.$i18n.t('Редактирование'),
          disabled: true
        }
      ]
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>
